var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "videoComponent" },
    [
      _c(
        "div",
        {
          ref: "container",
          staticClass: "video-container",
          class: { "has-bg": !!_vm.datas.bgSrc },
        },
        [
          _vm.datas.bgSrc
            ? _c("img", {
                staticClass: "bg-img",
                attrs: { src: _vm.reqPath + _vm.datas.bgSrc, alt: "" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.datas.videoSrc
            ? _c("video", {
                staticClass: "video-content",
                style: _vm.videoElStyle,
                attrs: {
                  src: _vm.reqPath + _vm.datas.videoSrc,
                  autoplay: _vm.datas.autoplay,
                  controls: _vm.datas.controls,
                  loop: false,
                  preload: "metadata",
                  playsinline: "",
                  "webkit-playsinline": "",
                },
                domProps: { muted: _vm.datas.autoplay },
                on: { loadedmetadata: _vm.onVideoMeta },
              })
            : _c("div", { staticClass: "video-placeholder" }, [
                _c("i", { staticClass: "el-icon-video-camera default-icon" }),
                _vm._v(" "),
                _c("p", [_vm._v("暂无视频")]),
              ]),
        ]
      ),
      _vm._v(" "),
      _vm._t("deles"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }